import { gridGutter1q4, fontSize12 } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

import theme from '../../../../js/shared/new-theme';

export const messageStyle = `
    display: flex;
    align-items: center;
    color: ${theme.palette.red[500].value};
    font-weight: 600;
    font-size: ${fontSize12};
    margin-top: ${gridGutter1q4}px;
`;
